import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Fiches from "@/pages/Fiches";
import Who from "@/pages/Who";
import Legal from "@/pages/Legal";
import Contact from "@/pages/Contact";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="min-h-screen bg-navy-950 text-slate-300 font-sans antialiased">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/fiches-cee" element={<Fiches />} />
            <Route path="/qui-sommes-nous" element={<Who />} />
            <Route path="/mentions-legales" element={<Legal />} />
            <Route path="/simulateur" element={<Navigate to="/fiches-cee" replace />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
      <WhatsAppButton />
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
}

export default App;
